var Tree = require('../src/tree.js')

module.exports = Tree;
